const translations = {
  de: {
    free: 'Kostenlos',
    personal: 'Persönlich',
    business: 'Business',
    enterprise: 'Enterprise'
  },
  ru: {
    free: 'Бесплатная',
    personal: 'Персональная',
    business: 'Бизнес',
    enterprise: 'Бизнес'
  },
  ua: {
    free: 'Безкоштовна',
    personal: 'Персональна',
    business: 'Бізнес',
    enterprise: 'Бізнес'
  }
};

module.exports = {
  translate: (plan, locale, defaultVelue) => {
    if (translations[locale]) {
      return translations[locale][plan.toLowerCase()] ?? defaultVelue;
    } else {
      return defaultVelue;
    }
  }
};
